"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const core_1 = require("@material-ui/core");
const styles_1 = require("@material-ui/core/styles");
const ExpandMore_1 = __importDefault(require("@material-ui/icons/ExpandMore"));
const react_1 = __importStar(require("react"));
const theme_1 = require("../../styles/theme");
const FormRendererHelpers_1 = require("../../utils/FormRendererHelpers");
const RepeatFieldWrapper_1 = require("./RepeatFieldWrapper");
const RepeatWrapper_1 = require("./RepeatWrapper");
const GroupWrapper = props => {
    const classes = useStyles();
    const { children, controlDefinition, onRemoveClick, repeatCount, repeatable, isOriginal } = props;
    const { openDeleteConfirmation } = (0, RepeatWrapper_1.useRepeatContext)();
    const handleRemoveClick = () => {
        onRemoveClick && onRemoveClick();
    };
    const canDelete = (0, react_1.useCallback)(() => {
        if (isOriginal && !(0, FormRendererHelpers_1.getAllowInitialDataDelete)(controlDefinition)) {
            return false;
        }
        return repeatCount > (0, FormRendererHelpers_1.getRepeatMin)(controlDefinition) && repeatable;
    }, [repeatCount, controlDefinition, repeatable, isOriginal]);
    const onDelete = (0, react_1.useCallback)((evt) => {
        evt.stopPropagation();
        openDeleteConfirmation(handleRemoveClick, (0, FormRendererHelpers_1.getDeleteConfirmationMessage)(controlDefinition));
    }, [controlDefinition]);
    return (react_1.default.createElement("div", { className: classes.container },
        react_1.default.createElement(core_1.Accordion, { elevation: 3, defaultExpanded: true, className: classes.wrapper },
            react_1.default.createElement(core_1.AccordionSummary, { expandIcon: react_1.default.createElement(ExpandMore_1.default, null), style: { alignItems: 'center' } },
                react_1.default.createElement(core_1.Typography, { className: classes.label }, controlDefinition.label),
                canDelete() && (react_1.default.createElement(core_1.Button, { size: 'small', className: classes.delete, variant: 'text', onClick: onDelete }, "Delete"))),
            react_1.default.createElement(core_1.AccordionDetails, null,
                react_1.default.createElement("div", { className: classes.fieldWrapper }, children)),
            repeatable && react_1.default.createElement(RepeatFieldWrapper_1.InstanceFooter, Object.assign({}, props)))));
};
const useStyles = (0, styles_1.makeStyles)(theme => ({
    container: {
        position: 'relative',
        marginBottom: 20,
    },
    wrapper: {
        width: '100%',
    },
    fieldWrapper: {
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
    },
    connector: {
        backgroundColor: theme_1.colors.grayPlaceholder,
        height: 50,
        width: 10,
        position: 'absolute',
        bottom: -33,
        right: 15,
    },
    label: { flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' },
    delete: { color: '#EB5757', height: 50 },
}));
exports.default = GroupWrapper;
//# sourceMappingURL=GroupWrapper.js.map